//
//
//

import G2 from '@antv/g2';

export default {
  name: 'intervalchart',
  props: ['chartData', 'chartId'],
  data() {
    return {
      data: [],
      id: '',
      intervalChart: {}
    };
  },
  watch: {
    chartData(newVal) {
      this.data = newVal;
      this.intervalChart.changeData(this.data);
    }
  },
  created() {
    this.id = this.chartId;
    this.data = this.chartData;
  },
  mounted() {
    this.intervalChart = new G2.Chart({
      container: this.id,
      forceFit: true,
      height: document.querySelector('#' + this.id + '').clientHeight,
      width: document.querySelector('#' + this.id + '').clientWidth,
      padding: 'auto'
    });
    var num = -1;
    this.data.forEach(e => {
      if (e.value > num) {
        num = e.value;
      }
    });
    num = (parseInt(num / 100) + 1) * 100;
    this.intervalChart.source(this.data, {
      value: {
        min: 0,
        max: num
      }
    });
    this.intervalChart.tooltip(false);
    this.intervalChart.interval().position('year*value');
    this.intervalChart.render();
  }
};
